import {selector, selectorFamily} from 'recoil';

import {ServiceRequestImportService} from '../../api/services/serviceRequestImport.service';

import {
  currentServiceRequestImportsState,
  importOfDevicesPageable,
  importOfDevicesQueryTrigger,
  importOfDevicesState,
  importPageable,
  openedImportRowsState,
  serviceRequestImportsOfContractState,
  serviceRequestImportsQueryTrigger,
  serviceRequestImportsState,
} from './atoms';

export const serviceRequestImportsQuery = selector({
  key: 'serviceRequestImportsQuery',
  get: async ({get}) => {
    get(serviceRequestImportsQueryTrigger);

    const res = await ServiceRequestImportService.getAll();

    return res.data;
  },

  set: ({set}, newValue) => {
    set(serviceRequestImportsState, newValue);
  },
});

export const serviceRequestImportsOfContractQuery = selectorFamily({
  key: 'serviceRequestImportsOfContractQuery',
  get:
    (id) =>
    async ({get}) => {
      get(serviceRequestImportsQueryTrigger);
      const pageable = get(importPageable);

      const res = await ServiceRequestImportService.getAll({
        spec: {
          taskId: Number(id),
        },
        pageable: {
          ...pageable,
          sort: ['importStartDate', 'DESC', 'createdDate', 'DESC'],
        },
      });

      return {
        ...res.data,
        data: res.data.content,
      };
    },

  set:
    (id) =>
    ({set}, newValue) => {
      set(serviceRequestImportsOfContractState, newValue);
    },
});

export const currentServiceRequestImportsQueryFamily = selectorFamily({
  key: 'currentServiceRequestImportsQuery',
  get:
    (id) =>
    async ({get}) => {
      get(serviceRequestImportsQueryTrigger);

      const res = await ServiceRequestImportService.getById(String(id));

      return res.data;
    },

  set:
    (id) =>
    ({get, set}, newValue) => {
      set(currentServiceRequestImportsState, newValue);
    },
});

export const isImportRowOpenedFamily = selectorFamily({
  key: 'isImportRowOpenedFamily',
  get:
    (id) =>
    ({get}) => {
      const opened = get(openedImportRowsState);

      return Boolean(opened.find((item) => item === id));
    },
});

export const importOfDevicesQuery = selector({
  key: 'importOfDevicesQuery',
  get: async ({get}) => {
    get(importOfDevicesQueryTrigger);
    const pageable = get(importOfDevicesPageable);

    const res = await ServiceRequestImportService.getAll({
      spec: {
        docType: 'DICTIONARY_UPDATE',
      },
      pageable: {
        ...pageable,
        sort: ['importStartDate', 'DESC', 'createdDate', 'DESC'],
      },
    });

    return res.data;
  },

  set: ({set}, newValue) => {
    set(importOfDevicesState, newValue);
  },
});
